module.exports = __webpack_public_path__ + "img/SE5562564129.27d9e9ab.svg";